import styled from '@emotion/styled';
import css from '@styled-system/css';

import { StyledCharCounter } from '../../components/Shared/Input/CharCounter/CharCounter';
import { StyledInnerLabel } from '../../components/Shared/Input/Label/InnerLabel';
import OuterLabel from '../../components/Shared/Input/Label/OuterLabel';
import { inlineEnd, inlineStart } from '../../internal/styles/direction';
import sx from '../../internal/styles/sx';
import StyledInput from '../Input/StyledInput';
import { InputContainer } from '../InputContainer';
import { InputFieldImageContainer } from '../InputFieldImage';
import { StyledInputIconContainer } from '../InputIconContainer';
import { TextAreaContainer } from '../TextArea/TextAreaContainer';
import { Container as ValidationIconContainer } from '../ValidationIcon';

const layoutStyles = css({
  display: 'flex',
  width: '100%',
  flexWrap: 'nowrap',
  position: 'relative',
  overflow: 'hidden',

  [`${OuterLabel}`]: {
    width: '100%',
    order: -1,
    flexGrow: 1,
  },

  [`> ${StyledInnerLabel}`]: {
    position: 'relative',
    height: '0px',
    width: '0px',
    overflow: 'visible',
    whiteSpace: 'nowrap',
    mb: '-18px',
    left: 'small',
    padding: '0 0 18px 0',
  },

  [`${InputContainer}, ${TextAreaContainer}`]: {
    px: 0,
    flexGrow: 1,
    flexShrink: 1,
    width: 'auto',
    [`> ${StyledInnerLabel}`]: {
      display: 'inline-block',
      boxSizing: 'border-box',
      px: '2x_small',
    },
  },
});

const baseInputFieldItemStyles = {
  borderStyle: 'solid',
  borderWidth: 0,
  borderTopWidth: 1,
  borderBottomWidth: 1,
};

const sideBorderProps = {
  borderWidth: 1,
  borderTopRadius: 1,
  borderBottomRadius: 1,
};

const inlineSpaceAndBorderStyles = css({
  [`${InputFieldImageContainer}, ${StyledInputIconContainer}, ${ValidationIconContainer}`]:
    {
      ...baseInputFieldItemStyles,
      px: '2x_small',
      ':first-of-type': {
        ...inlineStart({
          padding: 'small',
          ...sideBorderProps,
        }),

        [`~ ${StyledInnerLabel}`]: {
          left: '2x_small',
        },
      },
      ':last-child': {
        ...inlineEnd({
          padding: 'small',
          ...sideBorderProps,
        }),
      },
    },

  [`${InputContainer}, ${TextAreaContainer}`]: {
    ...baseInputFieldItemStyles,
    px: 0,
    borderRadius: 0,
    ':first-of-type': {
      ...inlineStart(sideBorderProps),
      [`${StyledInput}, ${StyledInnerLabel}`]: inlineStart({
        padding: 'small',
      }),
    },
    ':last-child': {
      ...inlineEnd(sideBorderProps),
      [`${StyledInput}, ${StyledInnerLabel}`]: inlineEnd({
        padding: 'small',
      }),
    },
  },

  [`${StyledCharCounter}`]: {
    ':first-of-type': {
      ...inlineEnd({
        right: 'base',
      }),
    },
  },

  [`${StyledInput}`]: {
    px: '2x_small',
  },

  [`${StyledInnerLabel}, ${OuterLabel}`]: {
    [`+ ${InputContainer}:first-of-type , ${TextAreaContainer}:first-of-type`]:
      {
        ...inlineStart(sideBorderProps),
        [`> ${StyledInput}`]: inlineStart({
          padding: 'small',
        }),
      },
  },
});

export const StyledField = styled('label')(
  layoutStyles,
  inlineSpaceAndBorderStyles,
  sx
);
